export default __webpack_public_path__ + "static/media/core_stem.5b47f51e.png";